module.exports = __webpack_public_path__ + "media/images/application/template/queens-trade-2018-74ce202644a5d3a2c25431fac46edc7d.svg";